import template from './transaction.html';
import controller from './transaction.controller';

let transactionComponent = {
  restrict: 'E',
  template,
  controller
};

export default transactionComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/quickbooks/capabilities/transaction/transaction.component.js